export default __webpack_public_path__ + "static/media/ocsb-abs.7282faaa.svg";